module.exports = __webpack_public_path__ + "49b2229183810681bdfced742b579886.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/cat-ears.png
// module id = 2167
// module chunks = 0